'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = 'M240 8l0-8L224 0l0 8 0 24c0 26.5 21.5 48 48 48l16 0 8 0 8 0 6.1 0-49.7 24.8-4.4 2.2 0 4.9 0 24 0 8 8 0 48 0 6.5 0-11.3 32L112 176s0 0 0 0l-24 0c-48.6 0-88 39.4-88 88l0 48 0 8 16 0 0-8 0-48c0-39.8 32.2-72 72-72l24 0s0 0 0 0l200.9 0 5.7 0 1.9-5.3 15-42.7 .6 0 8 0 0-16-2.9 0-5.1 0-6.2 0L312 128l-40 0 0-11.1L345.9 80l58.8 0L496 171.3l0 36.7-96 0-6.1 0-1.6 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7L368 496l-72 0 0-144 0-8-8 0-69.2 0L181 313.8l-16.3-13.1 3.4 20.6 7.1 42.9-43.7 29.1-5 3.3 1.8 5.7L157.2 496l-71.3 0L56.4 400.1l15.2-45.6 .4-1.2 0-1.3 0-32 0-4.3-3.6-2.4L43.8 296.9C39 293.7 35 289.5 32 284.7l0 23.4c1 .7 1.9 1.4 3 2.1l21 14 0 26.4L40.4 397.5l-.8 2.4 .8 2.5 32 104 1.7 5.6 5.9 0 88 0 10.8 0-3.2-10.4-30.2-98.3 43-28.7 4.3-2.9-.9-5.1-4.6-27.4L211 358.2l2.2 1.8 2.8 0 64 0 0 144 0 8 8 0 88 0 8 0 0-8 0-193.6c0-3.6 .5-7.1 1.4-10.5L406.1 224l97.9 0 8 0 0-8 0-48 0-3.3-2.3-2.3L427.2 79.9C452.2 78.2 472 57.4 472 32l0-24 0-8L456 0l0 8 0 24c0 17.7-14.3 32-32 32l-8 0-4.7 0L408 64s0 0 0 0l-64 0-1.9 0-2.3 0c7.6-8.5 12.2-19.7 12.2-32l0-24 0-8L336 0l0 8 0 24c0 17.7-14.3 32-32 32l-8 0-8 0-16 0c-17.7 0-32-14.3-32-32l0-24zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;